const getSkuBasesQuery = /* GraphQL */ `
  query GetSkuBases($skuBaseNumbers: [String], $webUserGuid: String) {
    skuBases(skuBaseNumbers: $skuBaseNumbers, webUserGuid: $webUserGuid) {
      skuBaseNumber
      displayTitle
      pricing {
        salePriceString
        strikeThroughPrice
        salePrice
      }
      rating
      reviewCount
      availability
      productPageUrl
      brand
      segmentCategorization
      superMarketAffinity
    }
  }
`

export default getSkuBasesQuery
